import classes from '@/components/Shares/Button.module.css';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useLingui } from '@lingui/react';
import { Button, Group } from '@mantine/core';
export const SendLinkButton: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setOpenModal
  } = useModalAction();
  return <Group w="100%" justify="center" mt={20}>
      <Button w="40%" h={40} p={0} fz="xs" classNames={classes} onClick={() => setOpenModal(MODAL.VERIFY_PASS)}>
        {i18n._('Send reset link')}
      </Button>
    </Group>;
};